import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import DeadlineModal from 'project/components/deadline_modal';
import { fetchProject } from 'project/ducks/project';
import { extendDeadline, toggleExtendModal, toggleExtendSuccessModal }
  from 'project/ducks/features';
import { getProjectIdFromUrl } from 'project/utils';

export function mapStateToProps(state, { params }) {
  return {
    projectId: getProjectIdFromUrl(params),
    showModal: state.project.features.showingExtendModal,
    showSuccessModal: state.project.features.showingExtendSuccessModal,
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const projectId = getProjectIdFromUrl(params);

  return bindActionCreators({
    extendDeadline,
    toggleExtendModal,
    toggleSuccessModal: toggleExtendSuccessModal,
    fetchProject: partial(fetchProject, projectId),
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeadlineModal));



// WEBPACK FOOTER //
// ./project/containers/deadline_modal.js